(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsen-modal/assets/javascripts/tipsen-modal.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsen-modal/assets/javascripts/tipsen-modal.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const Modal = svs.components.lbUi.modal.Modal;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback;
const useBranding = svs.components.tipsen.hooks.useBranding;
const _svs$components$sport = svs.components.sport.tipsenShared,
  actions = _svs$components$sport.actions,
  PARAM_ACTION = _svs$components$sport.PARAM_ACTION;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const TipsenModal = React.forwardRef((_ref, ref) => {
  let isOpen = _ref.isOpen,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$Bottom = _ref.Bottom,
    Bottom = _ref$Bottom === void 0 ? () => null : _ref$Bottom,
    _ref$scrollToEventOnC = _ref.scrollToEventOnClose,
    scrollToEventOnClose = _ref$scrollToEventOnC === void 0 ? false : _ref$scrollToEventOnC;
  const classNames = [];
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    el = _useState2[0],
    setEl = _useState2[1];
  const history = useHistory();
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  if (productBranding && productBranding.length > 0) {
    classNames.push("tipsen-modal-window--".concat(productBranding));
  }
  const setRef = useCallback(node => {
    if (!node) {
      return;
    }
    if (ref) {
      ref.current = node;
    }
    setEl(node);
  }, [ref]);
  useEffect(() => {
    var _document$querySelect, _document$querySelect2;
    if (!el) {
      return;
    }
    const topContentWrapper = ((_document$querySelect = document.querySelector('.js-top-content-wrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    const stickyBottom = ((_document$querySelect2 = document.querySelector('.sticky-bottom')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0;
    const reservedHeight = topContentWrapper + stickyBottom;
    el.style.setProperty('height', "calc(100svh - ".concat(reservedHeight, "px)"));
    const tipsenRootElem = document.querySelector('#tipsen');
    const tipsenRootElemPadding = tipsenRootElem === null || tipsenRootElem === void 0 ? void 0 : tipsenRootElem.style.paddingBottom;
    if (tipsenRootElem && isOpen) {
      tipsenRootElem.style.paddingBottom = '0px';
    }
    if (!isOpen && scrollToEventOnClose) {
      const search = new URLSearchParams(location.search);
      search.set(PARAM_ACTION, actions.CLOSE_MODAL);
      history.push({
        search: "?".concat(search)
      });
    }

    const hiddenContentMainElem = tipsenRootElem === null || tipsenRootElem === void 0 ? void 0 : tipsenRootElem.querySelector('.lb-modal-hidden-content main');
    if (hiddenContentMainElem) {
      if (isOpen) {
        hiddenContentMainElem.setAttribute('inert', '');
      } else {
        hiddenContentMainElem.removeAttribute('inert');
      }
    }
    return () => {
      if (tipsenRootElem) {
        tipsenRootElem.style.paddingBottom = tipsenRootElemPadding;
      }
      if (hiddenContentMainElem) {
        hiddenContentMainElem.removeAttribute('inert');
      }
    };
  }, [isOpen, el, scrollToEventOnClose, history]);
  className && classNames.push(className);
  return React.createElement(Modal, {
    className: ['tipsen-modal-window'].concat(classNames).join(' '),
    isOpen: isOpen
  }, React.createElement("main", {
    className: "tipsen-modal-handler",
    ref: setRef
  }, children), React.createElement(Bottom, null));
});
setGlobal('svs.components.tipsen.tipsenModal.TipsenModal', TipsenModal);

 })(window);